import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appDefaultViewContainerRef]'
})
export class DefaultViewContainerRefDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
